import { DictionaryBase } from './types';

const SysOperationType = new DictionaryBase('操作日志操作类型', [
  {
    id: 0,
    name: '登录',
    symbol: 'LOGIN',
  },
  {
    id: 1,
    name: '手机登录',
    symbol: 'MOBILE_LOGIN',
  },
  {
    id: 5,
    name: '登出',
    symbol: 'LOGOUT',
  },
  {
    id: 10,
    name: '新增',
    symbol: 'ADD',
  },
  {
    id: 15,
    name: '修改',
    symbol: 'UPDATE',
  },
  {
    id: 20,
    name: '删除',
    symbol: 'DELETE',
  },
  {
    id: 35,
    name: '查询',
    symbol: 'LIST',
  },
  {
    id: 40,
    name: '分组查询',
    symbol: 'LIST_WITH_GROUP',
  },
  {
    id: 45,
    name: '导出',
    symbol: 'EXPORT',
  },
  {
    id: 25,
    name: '新增多对多关联',
    symbol: 'ADD_M2M',
  },
  {
    id: 30,
    name: '移除多对多关联',
    symbol: 'DELETE_M2M',
  },
  {
    id: 50,
    name: '上传',
    symbol: 'UPLOAD',
  },
  {
    id: 55,
    name: '下载',
    symbol: 'DOWNLOAD',
  },
  {
    id: 60,
    name: '重置缓存',
    symbol: 'RELOAD_CACHE',
  },
  {
    id: 65,
    name: '发布',
    symbol: 'PUBLISH',
  },
  {
    id: 70,
    name: '取消发布',
    symbol: 'UNPUBLISH',
  },
  {
    id: 75,
    name: '流程挂起',
    symbol: 'SUSPEND',
  },
  {
    id: 80,
    name: '流程恢复',
    symbol: 'RESUME',
  },
  {
    id: 100,
    name: '启动流程',
    symbol: 'START_FLOW',
  },
  {
    id: 105,
    name: '终止流程',
    symbol: 'STOP_FLOW',
  },
  {
    id: 110,
    name: '删除流程',
    symbol: 'DELETE_FLOW',
  },
  {
    id: 115,
    name: '撤销流程',
    symbol: 'CANCEL_FLOW',
  },
  {
    id: 120,
    name: '提交流程任务',
    symbol: 'SUBMIT_TASK',
  },
  {
    id: 125,
    name: '催办流程',
    symbol: 'REMIND_TASK',
  },
  {
    id: 126,
    name: '流程干预',
    symbol: 'INTERVENE_FLOW',
  },
  {
    id: 127,
    name: '流程数据补偿',
    symbol: 'FIX_FLOW_BUSINESS_DATA',
  },
]);

const SysPermModuleType = new DictionaryBase('权限分组类型', [
  {
    id: 0,
    name: '分组模块',
    symbol: 'GROUP',
  },
  {
    id: 1,
    name: '接口模块',
    symbol: 'CONTROLLER',
  },
]);

const SysPermCodeType = new DictionaryBase('权限字类型', [
  {
    id: 0,
    name: '表单',
    symbol: 'FORM',
  },
  {
    id: 1,
    name: '片段',
    symbol: 'FRAGMENT',
  },
  {
    id: 2,
    name: '操作',
    symbol: 'OPERATION',
  },
]);

/**
 * 菜单类型
 *
 * DIRECTORY(0: 目录)
 * MENU(1: 表单)
 * FRAGMENT(2: 片段)
 * BUTTON(3: 按钮)
 */
const SysMenuType = new DictionaryBase('菜单类型', [
  {
    id: 0,
    name: '目录',
    symbol: 'DIRECTORY',
  },
  {
    id: 1,
    name: '菜单',
    symbol: 'MENU',
  },
  {
    id: 2,
    name: '片段',
    symbol: 'FRAGMENT',
  },
  {
    id: 3,
    name: '按钮',
    symbol: 'BUTTON',
  },
]);

const MobileEntryType = new DictionaryBase('移动端首页配置项类型', [
  {
    id: 0,
    name: '轮播图',
    symbol: 'BANNER',
  },
  {
    id: 1,
    name: '九宫格',
    symbol: 'SUDOKU',
  },
  {
    id: 2,
    name: '分组',
    symbol: 'GROUP',
  },
]);

/**
 * 菜单绑定类型
 *
 * ROUTER(0: 路由菜单)
 * ONLINE_FORM(1: 在线表单)
 * WORK_ORDER(2: 工单列表)
 * REPORT(3: 报表页面)
 * THRID_URL(4: 外部链接)
 */
const SysMenuBindType = new DictionaryBase('菜单绑定类型', [
  {
    id: 0,
    name: '路由菜单',
    symbol: 'ROUTER',
  },
  {
    id: 5,
    name: '路由工单',
    symbol: 'ROUTER_WORK_ORDER',
  },
  {
    id: 4,
    name: '外部链接',
    symbol: 'THRID_URL',
  },
]);

const SysDataPermType = new DictionaryBase('数据权限类型', [
  {
    id: 0,
    name: '查看全部',
    symbol: 'ALL',
  },
  {
    id: 1,
    name: '仅看自己',
    symbol: 'ONLY_USER',
  },
  {
    id: 2,
    name: '仅看所在部门',
    symbol: 'ONLY_DEPT',
  },
  {
    id: 3,
    name: '仅看所在部门及子部门',
    symbol: 'ONLY_DEPT_AND_CHILD',
  },
  {
    id: 4,
    name: '自选部门及子部门',
    symbol: 'CUSTOM_DEPT_AND_CHILD',
  },
  {
    id: 5,
    name: '仅自选部门',
    symbol: 'CUSTOM_DEPT',
  },
  {
    id: 6,
    name: '本部门用户',
    symbol: 'DEPT_USER',
  },
  {
    id: 7,
    name: '本部门及子部门用户',
    symbol: 'DEPT_AND_CHILD_USER',
  },
  {
    id: 20,
    name: '自定义',
    symbol: 'SQL',
  },
]);

const ScatterSymbolType = new DictionaryBase('纵轴位置', [
  {
    id: 0,
    name: '固定大小',
    symbol: 'FIXED',
  },
  {
    id: 1,
    name: '值大小',
    symbol: 'VALUE',
  },
]);

const SysCustomWidgetType = new DictionaryBase('组件类型', [
  {
    id: 0,
    name: '文本显示',
    symbol: 'Label',
  },
  {
    id: 1,
    name: '文本输入框',
    symbol: 'Input',
  },
  {
    id: 3,
    name: '数字输入框',
    symbol: 'NumberInput',
  },
  {
    id: 4,
    name: '数字范围输入框',
    symbol: 'NumberRange',
  },
  {
    id: 5,
    name: '开关组件',
    symbol: 'Switch',
  },
  {
    id: 6,
    name: '滑块组件',
    symbol: 'Slider',
  },
  {
    id: 7,
    name: '单选组件',
    symbol: 'Radio',
  },
  {
    id: 8,
    name: '复选框',
    symbol: 'CheckBox',
  },
  {
    id: 10,
    name: '下拉选择框',
    symbol: 'Select',
  },
  {
    id: 12,
    name: '级联选择框',
    symbol: 'Cascader',
  },
  {
    id: 13,
    name: '树形选择组件',
    symbol: 'Tree',
  },
  {
    id: 14,
    name: '评分组件',
    symbol: 'Rate',
  },
  {
    id: 15,
    name: '进步器',
    symbol: 'Stepper',
  },
  {
    id: 16,
    name: '日历组件',
    symbol: 'Calendar',
  },
  {
    id: 20,
    name: '日期选择框',
    symbol: 'Date',
  },
  {
    id: 21,
    name: '日期范围选择框',
    symbol: 'DateRange',
  },
  {
    id: 30,
    name: '颜色选择框',
    symbol: 'ColorPicker',
  },
  {
    id: 31,
    name: '上传组件',
    symbol: 'Upload',
  },
  {
    id: 32,
    name: '富文本编辑',
    symbol: 'RichEditor',
  },
  {
    id: 33,
    name: '单选按钮组',
    symbol: 'RadioButtonGroup',
  },
  {
    id: 40,
    name: '分割线',
    symbol: 'Divider',
  },
  {
    id: 41,
    name: '文本',
    symbol: 'Text',
  },
  {
    id: 42,
    name: '图片',
    symbol: 'Image',
  },
  {
    id: 44,
    name: '标题栏',
    symbol: 'Title',
  },
  {
    id: 45,
    name: '签名组件',
    symbol: 'Signature',
  },
  {
    id: 43,
    name: '超链接',
    symbol: 'Link',
  },
  {
    id: 100,
    name: '表格组件',
    symbol: 'Table',
  },
  {
    id: 101,
    name: '透视表',
    symbol: 'PivotTable',
  },
  {
    id: 102,
    name: '数据列表',
    symbol: 'List',
  },
  {
    id: 103,
    name: '查询列表',
    symbol: 'QueryList',
  },
  {
    id: 104,
    name: '工单列表',
    symbol: 'WorkOrderList',
  },
  {
    id: 200,
    name: '折线图',
    symbol: 'LineChart',
  },
  {
    id: 201,
    name: '柱状图',
    symbol: 'BarChart',
  },
  {
    id: 202,
    name: '饼图',
    symbol: 'PieChart',
  },
  {
    id: 203,
    name: '散点图',
    symbol: 'ScatterChart',
  },
  {
    id: 204,
    name: '普通表格',
    symbol: 'DataViewTable',
  },
  {
    id: 205,
    name: '轮播图',
    symbol: 'Carousel',
  },
  {
    id: 206,
    name: '富文本',
    symbol: 'RichText',
  },
  {
    id: 207,
    name: '仪表盘',
    symbol: 'GaugeChart',
  },
  {
    id: 208,
    name: '漏斗图',
    symbol: 'FunnelChart',
  },
  {
    id: 209,
    name: '雷达图',
    symbol: 'RadarChart',
  },
  {
    id: 210,
    name: '普通进度条',
    symbol: 'ProgressBar',
  },
  {
    id: 211,
    name: '环形进度条',
    symbol: 'ProgressCircle',
  },
  {
    id: 212,
    name: '通用卡片',
    symbol: 'DataCard',
  },
  {
    id: 213,
    name: '通用列表',
    symbol: 'CommonList',
  },
  {
    id: 214,
    name: '进度条卡片',
    symbol: 'DataProgressCard',
  },
  {
    id: 300,
    name: '基础块',
    symbol: 'Block',
  },
  {
    id: 301,
    name: '卡片组件',
    symbol: 'Card',
  },
  {
    id: 302,
    name: 'Tabs 组件',
    symbol: 'Tabs',
  },
  {
    id: 303,
    name: '图片卡片',
    symbol: 'ImageCard',
  },
  {
    id: 304,
    name: '分组容器',
    symbol: 'CellGroup',
  },
  {
    id: 400,
    name: '用户选择',
    symbol: 'UserSelect',
  },
  {
    id: 401,
    name: '部门选择',
    symbol: 'DeptSelect',
  },
  {
    id: 402,
    name: '关联选择',
    symbol: 'DataSelect',
  },
  {
    id: 403,
    name: '表格容器',
    symbol: 'TableContainer',
  },
  {
    id: 404,
    name: '字典选择',
    symbol: 'DictSelect',
  },
  {
    id: 405,
    name: '流程统计',
    symbol: 'FlowCountStatusCard',
  },
  {
    id: 406,
    name: '视频组件',
    symbol: 'Video',
  },
  {
    id: 407,
    name: '地图组件',
    symbol: 'MAP',
  },
  {
    id: 408,
    name: '二维码',
    symbol: 'QRCODE',
  },
  {
    id: 409,
    name: '条形码',
    symbol: 'BARCODE',
  },
  {
    id: 500,
    name: '单选过滤',
    symbol: 'MobileRadioFilter',
  },
  {
    id: 501,
    name: '多选过滤',
    symbol: 'MobileCheckBoxFilter',
  },
  {
    id: 502,
    name: '文本过滤',
    symbol: 'MobileInputFilter',
  },
  {
    id: 503,
    name: '开关过滤',
    symbol: 'MobileSwitchFilter',
  },
  {
    id: 504,
    name: '日期过滤',
    symbol: 'MobileDateRangeFilter',
  },
  {
    id: 505,
    name: '数字范围过滤',
    symbol: 'MobileNumberRangeFilter',
  },
  // 行内编辑组件
  {
    id: 600,
    name: '输入框',
    symbol: 'INLINE_INPUT',
  },
  {
    id: 601,
    name: '数字输入框',
    symbol: 'INLINE_NUMBER_INPUT',
  },
  {
    id: 602,
    name: '日期输入框',
    symbol: 'INLINE_DATE',
  },
  {
    id: 603,
    name: '下拉选择框',
    symbol: 'INLINE_SELECT',
  },
  {
    id: 604,
    name: '级联选择组件',
    symbol: 'INLINE_CASCADE',
  },
  {
    id: 605,
    name: '开关组件',
    symbol: 'INLINE_SWITCH',
  },
  {
    id: 606,
    name: '上传组件',
    symbol: 'INLINE_UPLOAD',
  },
]);

const OnlineFormEventType = new DictionaryBase('在线表单事件类型', [
  {
    id: 'change',
    name: '数据改变',
    symbol: 'CHANGE',
  },
  {
    id: 'blur',
    name: '失去焦点',
    symbol: 'BLUR',
  },
  {
    id: 'focus',
    name: '获取焦点',
    symbol: 'FOCUS',
  },
  {
    id: 'disable',
    name: '是否禁用',
    symbol: 'DISABLE',
  },
  {
    id: 'visible',
    name: '是否可见',
    symbol: 'VISIBLE',
  },
  {
    id: 'dropdownChange',
    name: '下拉数据改变',
    symbol: 'DROPDOWN_CHANGE',
  },
  {
    id: 'linkHerf',
    name: '链接地址',
    symbol: 'LINK_HERF',
  },
  {
    id: 'disabledDate',
    name: '日期是否可用',
    symbol: 'DISABLED_DATE',
  },
  {
    id: 'afterLoadTableData',
    name: '表格加载数据后',
    symbol: 'AFTER_LOAD_TABLE_DATA',
  },
  {
    id: 'beforeLoadTableData',
    name: '表格加载数据前',
    symbol: 'BEFORE_LOAD_TABLE_DATA',
  },
  {
    id: 'afterLoadFormData',
    name: '页面加载数据后',
    symbol: 'AFTER_LOAD_FORM_DATA',
  },
  {
    id: 'beforeLoadFormData',
    name: '页面加载数据前',
    symbol: 'BEFORE_LOAD_FORM_DATA',
  },
  {
    id: 'beforeCommitFormData',
    name: '页面数据提交前',
    symbol: 'BEFORE_COMMIT_FORM_DATA',
  },
  {
    id: 'formCreated',
    name: '页面创建完毕',
    symbol: 'AFTER_CREATE_FORM',
  },
  {
    id: 'tableOperationVisible',
    name: '操作是否可见',
    symbol: 'OPERATION_VISIBLE',
  },
  {
    id: 'tableOperationDisbled',
    name: '操作是否禁用',
    symbol: 'OPERATION_DISABLED',
  },
  {
    id: 'tableOperationClick',
    name: '操作点击事件',
    symbol: 'OPERATION_CLICK',
  },
  {
    id: 'tableCellClick',
    name: '单元格点击事件',
    symbol: 'CELL_CLICK',
  },
  {
    id: 'tableCellRender',
    name: '单元格渲染事件',
    symbol: 'CELL_RENDER',
  },
  {
    id: 'tableInlineValueChange',
    name: '数据改变',
    symbol: 'INLINE_VALUE_CHANGE',
  },
  {
    id: 'tableColumnTagType',
    name: '单元格标签类型',
    symbol: 'CELL_TAG_TYPE',
  },
  {
    id: 'footerData',
    name: '表尾数据',
    symbol: 'FOOTER_DATA',
  },
  {
    id: 'linkClick',
    name: '链接点击事件',
    symbol: 'LINK_CLICK',
  },
  {
    id: 'reportCellClick',
    name: '单元格点击事件',
    symbol: 'REPORT_CELL_CLICK',
  },
  {
    id: 'serieClick',
    name: '图表点击事件',
    symbol: 'SERIE_CLICK',
  },
]);

const SysOnlineRelationType = new DictionaryBase('关联类型', [
  {
    id: 0,
    name: '一对一关联',
    symbol: 'ONE_TO_ONE',
  },
  {
    id: 1,
    name: '一对多关联',
    symbol: 'ONE_TO_MANY',
  },
]);

/**
 * 表单类型
 *
 * QUERY(1: 查询表单)
 * ADVANCE_QUERY(2: 左树右表查询)
 * ONE_TO_ONE_QUERY(3: 一对一查询)
 * FORM(5: 编辑表单)
 * FLOW(10: 流程表单)
 * WORK_ORDER(11: 工单列表)
 * REPORT(50: 报表页面)
 */
const SysOnlineFormType = new DictionaryBase('表单类型', [
  {
    id: 1,
    name: '查询表单',
    symbol: 'QUERY',
  },
  {
    id: 2,
    name: '左树右表查询',
    symbol: 'ADVANCE_QUERY',
  },
  {
    id: 3,
    name: '一对一查询',
    symbol: 'ONE_TO_ONE_QUERY',
  },
  {
    id: 4,
    name: '分组查询',
    symbol: 'GROUP_QUERY',
  },
  {
    id: 5,
    name: '编辑表单',
    symbol: 'FORM',
  },
  {
    id: 10,
    name: '流程表单',
    symbol: 'FLOW',
  },
  {
    id: 11,
    name: '工单列表',
    symbol: 'WORK_ORDER',
  },
  {
    id: 50,
    name: '报表页面',
    symbol: 'REPORT',
  },
]);

const SysCustomWidgetOperationType = new DictionaryBase('操作类型', [
  {
    id: 0,
    name: '新建',
    symbol: 'ADD',
  },
  {
    id: 1,
    name: '编辑',
    symbol: 'EDIT',
  },
  {
    id: 2,
    name: '删除',
    symbol: 'DELETE',
  },
  {
    id: 3,
    name: '导出',
    symbol: 'EXPORT',
  },
  {
    id: 4,
    name: '导入',
    symbol: 'IMPORT',
  },
  {
    id: 5,
    name: '启动流程',
    symbol: 'START_FLOW',
  },
  {
    id: 10,
    name: '批量删除',
    symbol: 'BATCH_DELETE',
  },
  {
    id: 20,
    name: '表单操作',
    symbol: 'FORM',
  },
  {
    id: 21,
    name: '打印操作',
    symbol: 'PRINT',
  },
  {
    id: 22,
    name: '复制',
    symbol: 'COPY',
  },
  {
    id: 23,
    name: '更新数据',
    symbol: 'UPDATE',
  },
  {
    id: 24,
    name: '更新数据（弹窗）',
    symbol: 'UPDATE_DIALOG',
  },
  {
    id: 30,
    name: '保存',
    symbol: 'SAVE',
  },
  {
    id: 31,
    name: '取消',
    symbol: 'CANCEL',
  },
  {
    id: 40,
    name: '行内添加',
    symbol: 'INLINE_ADD',
  },
  {
    id: 41,
    name: '行内编辑',
    symbol: 'INLINE_EDIT',
  },
  {
    id: 50,
    name: '脚本操作',
    symbol: 'SCRIPT',
  },
  {
    id: 51,
    name: '下钻事件',
    symbol: 'DRILL',
  },
  {
    id: 52,
    name: '路由跳转',
    symbol: 'ROUTE',
  },
]);

const OnlineSystemVariableType = new DictionaryBase('系统变量类型', [
  {
    id: 0,
    name: '登录用户',
    symbol: 'CURRENT_USER',
  },
  {
    id: 1,
    name: '所属部门',
    symbol: 'CURRENT_DEPT',
  },
  {
    id: 10,
    name: '当前日期',
    symbol: 'CURRENT_DATE',
  },
  {
    id: 11,
    name: '当前时间',
    symbol: 'CURRENT_TIME',
  },
  {
    id: 20,
    name: '流程发起人',
    symbol: 'FLOW_CREATE_USER',
  },
]);

const SysCustomWidgetBindDataType = new DictionaryBase('组件绑定数据类型', [
  {
    id: 0,
    name: '字段',
    symbol: 'Column',
  },
  {
    id: 5,
    name: '系统变量',
    symbol: 'SYSTEM_VARIABLE',
  },
  {
    id: 10,
    name: '自定义字段',
    symbol: 'Custom',
  },
  {
    id: 20,
    name: '固定值',
    symbol: 'Fixed',
  },
]);

const SysMaskFieldType = new DictionaryBase('脱敏类型', [
  {
    id: 'CUSTOM',
    name: '自定义',
    symbol: 'CUSTOM',
  },
  {
    id: 'NAME',
    name: '姓名',
    symbol: 'NAME',
  },
  {
    id: 'MOBILE_PHONE',
    name: '移动电话',
    symbol: 'MOBILE_PHONE',
  },
  {
    id: 'FIXED_PHONE',
    name: '座机电话',
    symbol: 'FIXED_PHONE',
  },
  {
    id: 'ID_CARD',
    name: '身份证',
    symbol: 'ID_CARD',
  },
  {
    id: 'BANK_CARD',
    name: '银行卡号',
    symbol: 'BANK_CARD',
  },
  {
    id: 'CAR_LICENSE',
    name: '汽车牌照号',
    symbol: 'CAR_LICENSE',
  },
  {
    id: 'EMAIL',
    name: '电子邮箱地址',
    symbol: 'EMAIL',
  },
  {
    id: 'PASSWORD',
    name: '密码',
    symbol: 'PASSWORD',
  },
]);

const EnumFileType = new DictionaryBase('文件类型', [
  {
    id: 1,
    name: '图片',
    symbol: 'IMAGE',
  },
  {
    id: 2,
    name: '音频',
    symbol: 'AUDIO',
  },
  {
    id: 3,
    name: '视频',
    symbol: 'VIDEO',
  },
  {
    id: 4,
    name: 'PDF',
    symbol: 'PDF',
  },
  {
    id: 5,
    name: 'Word',
    symbol: 'WORD',
  },
  {
    id: 6,
    name: 'Excel',
    symbol: 'EXCEL',
  },
  /*
  {
    id: 7,
    name: 'PPT',
    symbol: 'PPT',
  },
  {
    id: 8,
    name: '文本',
    symbol: 'TEXT',
  },
  {
    id: 9,
    name: '压缩包',
    symbol: 'ZIP',
  },
  {
    id: 10,
    name: 'Markdown',
    symbol: 'MARKDOWN',
  },
  {
    id: 11,
    name: 'HTML',
    symbol: 'HTML',
  },
  */
  {
    id: 999,
    name: '其他文件',
    symbol: 'FILE',
  },
]);

const SysOnlineDictType = new DictionaryBase('字典类型', [
  {
    id: 1,
    name: '数据表字典',
    symbol: 'TABLE',
  },
  {
    id: 5,
    name: 'URL字典',
    symbol: 'URL',
  },
  /*
  {
    id: 10,
    name: '静态字典',
    symbol: 'STATIC',
  },
  */
  {
    id: 20,
    name: '编码字典',
    symbol: 'CODE',
  },
  {
    id: 15,
    name: '自定义字典',
    symbol: 'CUSTOM',
  },
]);

const DirectionType = new DictionaryBase('方向', [
  {
    id: 0,
    name: '横轴',
    symbol: 'HORIZONTAL',
  },
  {
    id: 1,
    name: '纵轴',
    symbol: 'VERTICAL',
  },
]);

const DblinkType = new DictionaryBase('数据库连接类型', [
  {
    id: 0,
    name: 'MySQL',
    symbol: 'MYSQL',
  },
  {
    id: 1,
    name: 'PostgreSQL',
    symbol: 'POSTGRESQL',
  },
  {
    id: 2,
    name: 'Oracle',
    symbol: 'ORACLE',
  },
  {
    id: 6,
    name: 'SQL Server',
    symbol: 'SQL_SERVER',
  },
  {
    id: 3,
    name: '达梦数据库',
    symbol: 'DM_DB',
  },
  {
    id: 4,
    name: '人大金仓',
    symbol: 'KINGBASE',
  },
  {
    id: 5,
    name: '华为高斯',
    symbol: 'OPENGAUSS',
  },
  {
    id: 10,
    name: 'ClickHouse',
    symbol: 'CLICK_HOUSE',
  },
  {
    id: 11,
    name: 'Doris',
    symbol: 'DORIS',
  },
]);

const CriteriaFilterType = new DictionaryBase('条件过滤类型', [
  {
    id: 0,
    name: '等于',
    symbol: 'EQ',
  },
  {
    id: 1,
    name: '不等于',
    symbol: 'NOT_EQ',
  },
  {
    id: 2,
    name: '大于等于',
    symbol: 'GE',
  },
  {
    id: 3,
    name: '大于',
    symbol: 'GT',
  },
  {
    id: 4,
    name: '小于等于',
    symbol: 'LE',
  },
  {
    id: 5,
    name: '小于',
    symbol: 'LT',
  },
  {
    id: 6,
    name: 'LIKE',
    symbol: 'LIKE',
  },
  {
    id: 7,
    name: 'IN',
    symbol: 'IN',
  },
  {
    id: 8,
    name: 'NOT IN',
    symbol: 'NOT_IN',
  },
  {
    id: 9,
    name: 'BETWEEN',
    symbol: 'BETWEEN',
  },
  {
    id: 100,
    name: '不为空',
    symbol: 'NOT_NULL',
  },
  {
    id: 101,
    name: '为空',
    symbol: 'IS_NULL',
  },
]);

const FormulaItemKind = new DictionaryBase('公式项类型', [
  {
    id: 'varable',
    name: '变量',
    symbol: 'VARABLE',
  },
  {
    id: 'number',
    name: '数字',
    symbol: 'NUMBER',
  },
  {
    id: 'string',
    name: '字符串',
    symbol: 'STRING',
  },
  {
    id: 'operator',
    name: '操作符',
    symbol: 'OPERATOR',
  },
  {
    id: 'function',
    name: '函数',
    symbol: 'FUNCTION',
  },
]);

const SysOnlineRuleType = new DictionaryBase('验证规则类型', [
  {
    id: 1,
    name: '只允许整数',
    symbol: 'INTEGER_ONLY',
  },
  {
    id: 2,
    name: '只允许数字',
    symbol: 'DIGITAL_ONLY',
  },
  {
    id: 3,
    name: '只允许英文字符',
    symbol: 'LETTER_ONLY',
  },
  {
    id: 4,
    name: '范围验证',
    symbol: 'RANGE',
  },
  {
    id: 5,
    name: '邮箱格式验证',
    symbol: 'EMAIL',
  },
  {
    id: 6,
    name: '手机格式验证',
    symbol: 'MOBILE',
  },
  {
    id: 100,
    name: '自定义验证',
    symbol: 'CUSTOM',
  },
]);

const LogicOperatorType = new DictionaryBase('逻辑运算符', [
  {
    id: 'AND',
    name: '且',
    symbol: 'AND',
  },
  {
    id: 'OR',
    name: '或',
    symbol: 'OR',
  },
]);

const CustomQueryFilterValueType = new DictionaryBase('自定义查询过滤值类型', [
  {
    id: 0,
    name: '固定值',
    symbol: 'FIXED',
  },
  {
    id: 1,
    name: '字典值',
    symbol: 'DICT',
  },
]);

const SysUserStatus = new DictionaryBase('用户状态', [
  {
    id: 0,
    name: '正常状态',
    symbol: 'NORMAL',
  },
  {
    id: 1,
    name: '锁定状态',
    symbol: 'LOCKED',
  },
]);

const MemberLevel = new DictionaryBase('会员等级', [
  {
    id: 1,
    name: 'N1',
    symbol: '1',
  },
  {
    id: 2,
    name: 'N2',
    symbol: '2',
  },
  {
    id: 3,
    name: 'N3',
    symbol: '3',
  },
  {
    id: 4,
    name: 'N4',
    symbol: '4',
  },
  {
    id: 5,
    name: 'N5',
    symbol: '5',
  },
  {
    id: 6,
    name: 'N6',
    symbol: '6',
  },
  {
    id: 7,
    name: 'N7',
    symbol: '7',
  },
  {
    id: 8,
    name: 'N8',
    symbol: '8',
  },
  {
    id: 9,
    name: 'N9',
    symbol: '9',
  },
  {
    id: 10,
    name: 'N10',
    symbol: '10',
  },
]);

const SysUserType = new DictionaryBase('用户类型', [
  {
    id: 0,
    name: '管理员',
    symbol: 'ADMIN',
  },
  {
    id: 1,
    name: '系统操作员',
    symbol: 'SYSTEM',
  },
  {
    id: 2,
    name: '普通操作员',
    symbol: 'OPERATOR',
  },
]);

const MaterialsAuditStatus = new DictionaryBase('素材审核状态', [
  {
    id: 'PENDING_REVIEW',
    name: '待审核',
    symbol: 'PENDING_REVIEW',
  },
  {
    id: 'PASS',
    name: '审核通过',
    symbol: 'PASS',
  },
  {
    id: 'REJECT',
    name: '审核驳回',
    symbol: 'REJECT',
  },
]);

const Gender = new DictionaryBase('性别', [
  {
    id: 1,
    name: '男',
    symbol: 'MALE',
  },
  {
    id: 2,
    name: '女',
    symbol: 'FEMALE',
  },
]);

const MemberType = new DictionaryBase('会员类型', [
  {
    id: 1,
    name: '验配师',
    symbol: 'FITTING_TECHNICIAN',
  },
  {
    id: 0,
    name: '普通用户',
    symbol: 'ORDINARY_USER',
  },
]);

const ParameterType = new DictionaryBase('字段类型', [
  {
    id: 'STRING',
    name: 'STRING',
    symbol: 'STRING',
  },
  {
    id: 'INTEGER',
    name: 'INTEGER',
    symbol: 'INTEGER',
  },
  {
    id: 'DOUBLE',
    name: 'DOUBLE',
    symbol: 'DOUBLE',
  },
  {
    id: 'LONG',
    name: 'LONG',
    symbol: 'LONG',
  },
]);

const TestProgressStatus = new DictionaryBase('测试进度状态', [
  {
    id: 0,
    name: '未开始',
    symbol: 'NOT_STARTED',
    tagType: 'info',
  },
  {
    id: 1,
    name: '进行中',
    symbol: 'IN_PROGRESS',
    tagType: 'primary',
  },
  {
    id: 2,
    name: '已完成',
    symbol: 'COMPLETED',
    tagType: 'warning',
    color: 'success',
  },
  {
    id: 3,
    name: '已生成报告',
    symbol: 'REPORTED',
    tagType: 'success',
    color: 'success',
  },
]);

const TestType = new DictionaryBase('测试类型', [
  {
    id: 1,
    name: '全面测试',
    symbol: 'COMPREHENSIVE',
    tagType: 'success',
  },
  {
    id: 2,
    name: '单项测试',
    symbol: 'INDIVIDUAL',
    tagType: 'warning',
  },
]);

const ScreeningProgressStatus = new DictionaryBase('筛查进度状态', [
  {
    id: 0,
    name: '未开始',
    symbol: 'NOT_STARTED',
    tagType: 'info'
  },
  {
    id: 1,
    name: '进行中',
    symbol: 'IN_PROGRESS',
    tagType: 'primary'
  },
  {
    id: 2,
    name: '已完成',
    symbol: 'COMPLETED',
    tagType: 'warning',
    color: 'success',
  },
  {
    id: 3,
    name: '已生成报告',
    symbol: 'REPORTED',
    tagType: 'success',
    color: 'success',
  },
  {
    id: 4,
    name: '已取消',
    symbol: 'CANCELLED',
    tagType: 'danger',
    color: 'danger',
  },
]);

const QuestionnaireStatus = new DictionaryBase('问卷状态', [
  {
    id: 0,
    name: '启用',
    symbol: 'ENABLE'
  },
  {
    id: 1,
    name: '停用',
    symbol: 'STOP'
  }
]);

const QuestionType = new DictionaryBase('题目题型', [
  {
    id: 0,
    name: '单选',
    symbol: 'SELECT'
  },
  {
    id: 1,
    name: '问答',
    symbol: 'QUESTION'
  }
]);

const QuestionIsRequired = new DictionaryBase('题目是否必答', [
  {
    id: 0,
    name: '必答',
    symbol: 'YES'
  },
  {
    id: 1,
    name: '非必答',
    symbol: 'NO'
  }
]);

const QuestionNaireColor = new DictionaryBase('问卷主题色', [
  {
    id: '#A2E6BE',
    name: '薄荷绿',
    symbol: '#A2E6BE'
  },
  {
    id: '#FFD2D2',
    name: '玫瑰粉',
    symbol: '#FFD2D2'
  },
  {
    id: '#C9DFFF',
    name: '淡雾蓝',
    symbol: '#C9DFFF'
  },
  {
    id: '#FFE4BF',
    name: '香槟黄',
    symbol: '#FFE4BF'
  },
  {
    id: '#E5DDFF',
    name: '薰衣紫',
    symbol: '#E5DDFF'
  }
]);

const QuestionNaireLableColor = new DictionaryBase('问卷评估标签主题色', [
  {
    id: '#15803D',
    name: '绿色',
    symbol: '#15803D'
  },
  {
    id: '#0680CD',
    name: '蓝色',
    symbol: '#0680CD'
  },
  {
    id: '#F6C867',
    name: '黄色',
    symbol: '#F6C867'
  },
  {
    id: '#F28521',
    name: '橙色',
    symbol: '#F28521'
  },
  {
    id: '#DC4A38',
    name: '红色',
    symbol: '#DC4A38'
  },
  {
    id: '#8B0000',
    name: '深红色',
    symbol: '#8B0000'
  }
]);

const ScoringMethod = new DictionaryBase('问卷评分方式', [
  {
    id: 'option_score_cumulative',
    name: '选项分值累加',
    symbol: 'QPTION_SCORE_CUMULATIVE'
  }
]);
const TotalScoreMethod = new DictionaryBase('总分计算方式', [
  {
    id: 0,
    name: '单项累加',
    symbol: '总分等于各个题目得分累加'
  },
  {
    id: 1,
    name: '耳鸣TFI总分计算',
    symbol: '<p><strong>1.量表构成与评分范围</strong><br>  <strong>问题数量</strong>：TFI共包含25个自我报告项目（问题）。<br>  <strong>评分尺度：</strong>大多数问题采用0到10的数字评分尺度，其中0表示"没有影响/无此困扰",10<br>  表示"极度影响/极度困扰".<br>     <strong>注意：</strong>有些问题（如第1题和第3题）的回答是百分比，需要将百分比值<strong>除以10转换为0<br>     到10</strong>的数字分数。<br><strong>2.计算综合总分（global tfi score)</strong><br>TFI的综合总分范围是0到100分。计算步骤如下：<br><strong>步骤一：总和有效得分</strong><br>将受测者对所有25个问题的有效回答分数（0到10)相加，得出总得分。<br>(如果所有问题都回答10分，总和为250分。)<br><strong>步骤二：计算平均项目得分</strong><br>将总得分除以受测者提供有效答案的问题数量，得出平均项目得分。<br>平均项目得分 = 总得分/有效回答的问题数量<br><strong>步骤三：计算最终TFI总分</strong><br>将平均项目得分乘以10,即可得到0到100范围内的最终tfi总分。<br>TFI综合总分 = 平均项目得分x10</p>'
  },
  {
    id: 2,
    name: '感性需求评估',
    symbol: '<h4>评估逻辑</h4><p>最终得分以平均分计算，平均分值越高，表明个体越关注事物带来的主观感受，倾向于伟了情绪体验而付诸行动。</p><ul class="ne-ul"><li><p>子量表：分为趋近性感性需求（针对积极情况）和回避性感性需求（针对消极情绪），各5项，分别计算平均分。</p></li><li><p>感性需求子量表分级与解释</p></li></ul><table class="ne-table" style="min-width: 100px"><colgroup><col style="min-width: 25px"><col style="min-width: 25px"><col style="min-width: 25px"><col style="min-width: 25px"></colgroup><tbody><tr><td colspan="1" rowspan="1"><p class="ne-p">维度</p></td><td colspan="1" rowspan="1"><p class="ne-p">分级</p></td><td colspan="1" rowspan="1"><p class="ne-p">平均分范围</p></td><td colspan="1" rowspan="1"><p class="ne-p">简明解释</p></td></tr><tr><td colspan="1" rowspan="1"><p class="ne-p">趋近性（积极情感）</p></td><td colspan="1" rowspan="1"><p class="ne-p">偏低</p></td><td colspan="1" rowspan="1"><p class="ne-p">≤-1</p></td><td colspan="1" rowspan="1"><p class="ne-p">偏理性，不太受情绪影响</p></td></tr><tr><td colspan="1" rowspan="1"><p></p></td><td colspan="1" rowspan="1"><p class="ne-p">中等</p></td><td colspan="1" rowspan="1"><p class="ne-p">-0.9~0.9</p></td><td colspan="1" rowspan="1"><p class="ne-p">情绪感适中，不偏感性也不偏理性</p></td></tr><tr><td colspan="1" rowspan="1"><p></p></td><td colspan="1" rowspan="1"><p class="ne-p">偏高</p></td><td colspan="1" rowspan="1"><p class="ne-p">≥1</p></td><td colspan="1" rowspan="1"><p class="ne-p">比较感性、容易被情绪带动</p></td></tr><tr><td colspan="1" rowspan="1"><p class="ne-p">回避性（消极情绪）</p></td><td colspan="1" rowspan="1"><p class="ne-p">偏低</p></td><td colspan="1" rowspan="1"><p class="ne-p">≤-1</p></td><td colspan="1" rowspan="1"><p class="ne-p">能接受消极情绪，不刻意躲</p></td></tr><tr><td colspan="1" rowspan="1"><p></p></td><td colspan="1" rowspan="1"><p class="ne-p">中等</p></td><td colspan="1" rowspan="1"><p class="ne-p">-0.9~0.9</p></td><td colspan="1" rowspan="1"><p class="ne-p">对消极情绪态度平和，不抵触也不敏感</p></td></tr><tr><td colspan="1" rowspan="1"><p></p></td><td colspan="1" rowspan="1"><p class="ne-p">偏高</p></td><td colspan="1" rowspan="1"><p class="ne-p">≥1</p></td><td colspan="1" rowspan="1"><p class="ne-p">怕消极情绪，会刻意压抑自己</p></td></tr></tbody></table><h4>综合评估</h4><p class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">先分别判定 “趋近性（积极情感）” 和 “回避性（消极情绪）” 两个子量表的分级（高 / 中 / 低），再通过两者的组合，确定个体整体的情感需求模式，核心是 “看积极情感的追求倾向 + 消极情绪的应对态度”。</span></p><table class="ne-table" style="min-width: 100px"><colgroup><col style="min-width: 25px"><col style="min-width: 25px"><col style="min-width: 25px"><col style="min-width: 25px"></colgroup><tbody><tr><td colspan="1" rowspan="1" style="background-color: rgb(242, 242, 242)"><p style="text-align: left" class="ne-p"><span style="color: rgb(0, 0, 0); font-size: 16px"><strong>组合类型</strong></span></p></td><td colspan="1" rowspan="1" style="background-color: rgb(242, 242, 242)"><p style="text-align: left" class="ne-p"><span style="color: rgb(0, 0, 0); font-size: 16px"><strong>趋近性级别</strong></span></p></td><td colspan="1" rowspan="1" style="background-color: rgb(242, 242, 242)"><p style="text-align: left" class="ne-p"><span style="color: rgb(0, 0, 0); font-size: 16px"><strong>回避性级别</strong></span></p></td><td colspan="1" rowspan="1" style="background-color: rgb(242, 242, 242)"><p style="text-align: left" class="ne-p"><span style="color: rgb(0, 0, 0); font-size: 16px"><strong>核心特征（简明解读）</strong></span></p></td></tr><tr><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">1. 情感开放型</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">高</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">低</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">既感性、容易被积极情绪带动，也能接受消极情绪，不刻意躲避负面感受</span></p></td></tr><tr><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">2. 矛盾感性型</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">高</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">高</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">很容易被积极情绪带动，但又怕消极情绪，遇到不开心会刻意压抑自己</span></p></td></tr><tr><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">3. 理性淡漠型</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">低</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">低</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">偏理性、不太受情绪影响，对积极情感没太强追求，也不抵触消极情绪</span></p></td></tr><tr><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">4. 情绪回避型</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">低</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">高</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">既不怎么关注积极情感，又怕消极情绪，遇到不开心会躲，整个人情绪感弱且怕麻烦</span></p></td></tr><tr><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">5. 温和平衡型</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">中</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">中</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">情绪感适中，不偏感性也不偏理性，对消极情绪态度平和，既不刻意追开心，也不刻意躲负面</span></p></td></tr><tr><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">6. 轻度趋近型</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">高</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">中</span></p></td><td colspan="1" rowspan="1"><p style="text-align: left" class="ne-p"><span style="color: rgba(0, 0, 0, 0.85); font-size: 16px">容易被积极情绪带动，对消极情绪态度平和，不算怕负面感受，但也不会主动接纳</span></p></td></tr></tbody></table>'
  },
  {
    id: 3,
    name: '医院焦虑抑郁量表',
    symbol: 'HAD 共由 14 个条目组成，其中 7 个条目评定抑郁，7 个条目评定焦虑。共有 6 条反向提问条目,5条在抑郁分量表，1条在焦虑分量表，这就导致了评分方式有些不均衡。采用 HAD 的主要目的是进行焦虑、抑郁的筛选检查，因此重要的一点是确定一个公认的临界值。各研究中所采用的临界值不尽相同。按原作者的标准，焦虑与抑郁两个分量表的分值划分为 0-7分属无症状; 8-10分属症状可疑; 11-21分属肯定存在症状。'
  },
  {
    id: 4,
    name: '睡眠质量指数',
    symbol: '<div style="text-align:left"><img src="https://hht-api.chiltoon.com/admin/commonext/util/download?filename=e16036e66e964d869f0375534b0eab03.png" alt="image (3).png" width="100%" height="auto" data-align="left"></div><div style="text-align:left"><img src="https://hht-api.chiltoon.com/admin/commonext/util/download?filename=e2a05630c7f14125b850d260c32aa7db.png" alt="image (4).png" width="100%" height="auto" data-align="left"></div><div style="text-align:left"><img src="https://hht-api.chiltoon.com/admin/commonext/util/download?filename=6b28e0b7bb25472cba1c396fa8f50508.png" alt="image (5).png" width="100%" height="auto" data-align="left"></div><p></p>'
  }
]);
const tscmTwo = new DictionaryBase('感性需求评估高中低评分', [
  {
    id: 0,
    name: '偏低',
    symbol: '偏低'
  },
  {
    id: 1,
    name: '中等',
    symbol: '中等'
  },
  {
    id: 2,
    name: '偏高',
    symbol: '偏高'
  }
]);
// 添加获取标签类型的方法
(ScreeningProgressStatus as any).getTagType = function (id: number): string {
  const item = this.get(id);
  return (item as any)?.tagType || 'info';
};

export {
  SysDataPermType,
  SysOperationType,
  SysPermModuleType,
  SysPermCodeType,
  SysMenuBindType,
  MobileEntryType,
  SysMenuType,
  ScatterSymbolType,
  SysCustomWidgetType,
  OnlineFormEventType,
  SysOnlineFormType,
  SysCustomWidgetOperationType,
  OnlineSystemVariableType,
  SysCustomWidgetBindDataType,
  SysMaskFieldType,
  EnumFileType,
  SysOnlineDictType,
  DirectionType,
  DblinkType,
  CriteriaFilterType,
  FormulaItemKind,
  SysOnlineRuleType,
  LogicOperatorType,
  CustomQueryFilterValueType,
  SysOnlineRelationType,
  SysUserStatus,
  SysUserType,
  MaterialsAuditStatus,
  Gender,
  MemberType,
  ParameterType,
  MemberLevel,
  TestProgressStatus,
  TestType,
  ScreeningProgressStatus,
  QuestionnaireStatus,
  QuestionType,
  QuestionIsRequired,
  ScoringMethod,
  TotalScoreMethod,
  QuestionNaireColor,
  QuestionNaireLableColor,
  tscmTwo,
};
